export async function registerPublicShowServiceWorker(): Promise<void> {
  if (!("serviceWorker" in navigator)) return;
  const registration = await navigator.serviceWorker.register("/service-worker.js", { scope: "/" });
  await navigator.serviceWorker.ready;
  const urls = new Set<string>([new URL("/", window.location.origin).href]);
  for (
    const element of document.querySelectorAll<HTMLScriptElement | HTMLLinkElement>(
      "script[src], link[rel='stylesheet'][href], link[rel='icon'][href]",
    )
  ) {
    const value = element instanceof HTMLScriptElement ? element.src : element.href;
    if (value) urls.add(value);
  }
  for (const entry of performance.getEntriesByType("resource")) urls.add(entry.name);
  (registration.active ?? registration.waiting ?? registration.installing)?.postMessage({
    type: "PRIME_SHELL",
    urls: [...urls],
  });
}
